import React from "react";
import DebitCard from "views/lib/components/debit-card";

const UserProfileCards = ({ cards = [] }) => {
  if (!cards) return null;

  return (
    <div className="row">
      {cards.map((value, index) =>
        <div
          key={index}
          className="col-12 col-md-6"
        >
          <DebitCard userCard={value}/>
        </div>)
      }
    </div>
  );
};

export default React.memo(UserProfileCards);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-profile-cards.js